import { render } from "./ThirdTierAgent.vue?vue&type=template&id=18532ff9&scoped=true"
import script from "./ThirdTierAgent.vue?vue&type=script&lang=js"
export * from "./ThirdTierAgent.vue?vue&type=script&lang=js"

import "./ThirdTierAgent.vue?vue&type=style&index=0&id=18532ff9&lang=scss&scoped=true"

import exportComponent from "E:\\zhouwang\\work\\web_dev\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-18532ff9"]])

export default __exports__